import { combineReducers } from '@reduxjs/toolkit'
import { routerReducer } from 'react-router-redux'
import appReducer from './app/reducers.jsx';

const rootReducer = combineReducers({
  routing: routerReducer,
  app: appReducer,
});

export default rootReducer;
